<template>
  <main class="login" role="main">
    <SpPasswordHeader v-if="!noHeader" />
    <div class="body">
      <div class="box">
        <slot />
      </div>
      <div v-if="$slots['link']" class="link">
        <slot name="link" />
      </div>
    </div>
  </main>
</template>

<script>
import SpPasswordHeader from '@/components/molecules/SpPasswordHeader'

/**
 * ログイン画面のレイアウト
 */
export default {
  name: 'LoginLayout',
  components: {
    SpPasswordHeader,
  },
  props: {
    noHeader: { type: Boolean, default: false },
  },
}
</script>

<style lang="postcss" scoped>
.login {
  align-content: center;
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.body {
  align-items: center;
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.box {
  background-color: var(--white);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 472px;
  padding: 72px 56px 64px;
  width: 560px;
}

.button {
  align-self: center;
  letter-spacing: 1.05px;
  margin-top: auto;
  width: 384px;
}

.link {
  margin-top: 20px;
}

.responsive {
  @media screen and (max-width: 559px) {
    .login {
      height: auto;
    }

    .body {
      padding: 0;
    }

    .box {
      margin-top: 0;
      min-height: auto;
      padding: 44px 16px 40px;
      width: 100%;
    }

    .button {
      letter-spacing: 0.75px;
      margin-top: 40px;
      width: 100%;
    }
  }
}
</style>
